export default "__VITE_ASSET__DCRd1imb__"